/* global  */ // tUrl等のグローバル変数を宣言する

// import 'core-js/features/number/is-nan' // SwiperのIE対応
// import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function ($) {
  // ######   #######   #######  ##    ## #### ########
  // ##    ## ##     ## ##     ## ##   ##   ##  ##
  // ##       ##     ## ##     ## ##  ##    ##  ##
  // ##       ##     ## ##     ## #####     ##  ######
  // ##       ##     ## ##     ## ##  ##    ##  ##
  // ##    ## ##     ## ##     ## ##   ##   ##  ##
  //  ######   #######   #######  ##    ## #### ########
  /* global Cookies */
  // Cookies.remove('opFlag')
  const opFlag = Cookies.get('opFlag')
  if (opFlag !== 1) {
    Cookies.set('opFlag', 1, { expires: 1 / 24, path: '/' }) //Cookie定義
  }
  $(document).ready(function () {
    $('.MV-txtanime').addClass('active')
  })
  $('.Uarea_Btn').click(function () {
    $('.Uarea_Btn').removeClass('active')
    $(this).addClass('active')
  })
  $('#Case01BTN').click(function () {
    $(this).parents('.Uarea').find('.whitebox').addClass('V01')
    $(this).parents('.Uarea').find('.whitebox').removeClass('V02')
    $(this).parents('.Uarea').find('.botxt').addClass('V01')
    $(this).parents('.Uarea').find('.botxt').removeClass('V02')
  })
  $('#Case02BTN').click(function () {
    $(this).parents('.Uarea').find('.whitebox').addClass('V02')
    $(this).parents('.Uarea').find('.whitebox').removeClass('V01')
    $(this).parents('.Uarea').find('.botxt').addClass('V02')
    $(this).parents('.Uarea').find('.botxt').removeClass('V01')
  })
  // ######## ########  ##     ## ##    ## ##    ##  #######
  //    ##    ##     ## ##     ## ###   ## ##   ##  ##     ##
  //    ##    ##     ## ##     ## ####  ## ##  ##   ##     ##
  //    ##    ########  ##     ## ## ## ## #####     #######
  //    ##    ##   ##   ##     ## ##  #### ##  ##   ##     ##
  //    ##    ##    ##  ##     ## ##   ### ##   ##  ##     ##
  //    ##    ##     ##  #######  ##    ## ##    ##  #######
  function trunk8() {
    $('.js-t8.line3').trunk8({
      // 指定要素に行数制限をかける
      lines: 3,
      fill: '...',
    })
    $('.js-t8.line2').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...',
    })
    $('.js-t8.line1').trunk8({
      // 指定要素に行数制限をかける
      lines: 1,
      fill: '...',
    })
  }
  if ($('.js-t8')[0]) {
    // 要素を検出したら実行
    trunk8()
    $(window).on('load resize ', function () {
      trunk8()
    })
  }
  // ######  ##     ## ########  ######  ##    ## ########   #######  ##     ##
  // ##    ## ##     ## ##       ##    ## ##   ##  ##     ## ##     ##  ##   ##
  // ##       ##     ## ##       ##       ##  ##   ##     ## ##     ##   ## ##
  // ##       ######### ######   ##       #####    ########  ##     ##    ###
  // ##       ##     ## ##       ##       ##  ##   ##     ## ##     ##   ## ##
  // ##    ## ##     ## ##       ##    ## ##   ##  ##     ## ##     ##  ##   ##
  //  ######  ##     ## ########  ######  ##    ## ########   #######  ##     ##
  //クリック時の処理
  $('input[name="year[data][]"]').change(function () {
    $(this).siblings('.mwform-checkbox-field-text').toggleClass('active')
  })
  $('input[name="ppagreebtn[data][]"]').change(function () {
    $(this).siblings('.mwform-checkbox-field-text').toggleClass('active')
  })
  $('#triggerbtn-1').siblings('.mwform-radio-field-text').addClass('active')
  $('input[name="trigger"]').change(function () {
    var trigger = $(this).prop('checked')
    if (trigger) {
      // もしthisが選択状態だったら
      let add = $(this).val()
      console.log(add)
      if (add === '私塾界') {
        $('input[name="trigger"]').siblings('.mwform-radio-field-text').removeClass('active')
        $('#triggerbtn-1').siblings('.mwform-radio-field-text').addClass('active')
      } else if (add === '塾と教育') {
        $('input[name="trigger"]').siblings('.mwform-radio-field-text').removeClass('active')
        $('#triggerbtn-2').siblings('.mwform-radio-field-text').addClass('active')
      } else if (add === '展示会') {
        $('input[name="trigger"]').siblings('.mwform-radio-field-text').removeClass('active')
        $('#triggerbtn-3').siblings('.mwform-radio-field-text').addClass('active')
      } else if (add === 'ご紹介') {
        $('input[name="trigger"]').siblings('.mwform-radio-field-text').removeClass('active')
        $('#triggerbtn-4').siblings('.mwform-radio-field-text').addClass('active')
      } else if (add === 'WEB検索') {
        $('input[name="trigger"]').siblings('.mwform-radio-field-text').removeClass('active')
        $('#triggerbtn-5').siblings('.mwform-radio-field-text').addClass('active')
      } else if (add === 'その他') {
        $('input[name="trigger"]').siblings('.mwform-radio-field-text').removeClass('active')
        $('#triggerbtn-6').siblings('.mwform-radio-field-text').addClass('active')
      }
    }
  })
  $('#subjectbtn-1').siblings('.mwform-radio-field-text').addClass('active')
  $('input[name="subject"]').change(function () {
    var subject = $(this).prop('checked')
    if (subject) {
      // もしthisが選択状態だったら
      let add = $(this).val()
      console.log(add)
      if (add === '資料請求') {
        $('input[name="subject"]').siblings('.mwform-radio-field-text').removeClass('active')
        $('#subjectbtn-1').siblings('.mwform-radio-field-text').addClass('active')
      } else if (add === '説明会お申込み') {
        $('input[name="subject"]').siblings('.mwform-radio-field-text').removeClass('active')
        $('#subjectbtn-2').siblings('.mwform-radio-field-text').addClass('active')
      }
    }
  })
  // ##     ## ########    ###    ########  ######## ########
  // ##     ## ##         ## ##   ##     ## ##       ##     ##
  // ##     ## ##        ##   ##  ##     ## ##       ##     ##
  // ######### ######   ##     ## ##     ## ######   ########
  // ##     ## ##       ######### ##     ## ##       ##   ##
  // ##     ## ##       ##     ## ##     ## ##       ##    ##
  // ##     ## ######## ##     ## ########  ######## ##     ##
  function headercolor() {
    if (window.matchMedia('(min-width: 600px)').matches) {
      $('.header__frame').each(function () {
        var scroll = $(window).scrollTop() //スクロールした量を計測して変数に代入
        if (scroll > 350) {
          //395以上スクロールしたら処理実行
          $('.headerPulldown').addClass('active') //超過したときに該当のクラスにstopを追加
          $('.header__logo').addClass('active') //超過したときに該当のクラスにstopを追加
          $('.SingleVer').addClass('active')
        } else {
          //395以下の時スクロールしたら処理実行
          $('.headerPulldown').removeClass('active') //超過したときに該当のクラスにstopを追加
          $('.header__logo').removeClass('active') //超過したときに該当のクラスにstopを追加
          $('.SingleVer').removeClass('active')
        }
        if (scroll > 150) {
          $('.HOME').addClass('active')
          $('.HOMEV').addClass('homeVer')
        } else {
          //395以下の時スクロールしたら処理実行
          $('.HOME').removeClass('active')
          $('.HOMEV').removeClass('homeVer')
        }
      })
    } else {
      //600px以下の場合
    }
  }
  $(window).scroll(function () {
    //スクロール時に一度だけ行う処理
    //600px以上の場合
    headercolor()
  })
  $(document).ready(function () {
    headercolor()
  })
  // ########    ###    ########  ########         #### ##    ##
  // ##         ## ##   ##     ## ##                ##  ###   ##
  // ##        ##   ##  ##     ## ##                ##  ####  ##
  // ######   ##     ## ##     ## ######   #######  ##  ## ## ##
  // ##       ######### ##     ## ##                ##  ##  ####
  // ##       ##     ## ##     ## ##                ##  ##   ###
  // ##       ##     ## ########  ########         #### ##    ##
  function fadeinanime() {
    if (window.matchMedia('(min-width: 768px)').matches) {
      //768px以上の場合
      $('.fade-in').each(function () {
        let scroll = $(window).scrollTop() //TOPからのスクロール量を計測
        let position = $(this).offset().top //TOPからの位置を計測
        let windowHeight = $(window).height() //ページ全体の高さ計測
        if (scroll - 200 > position - windowHeight) {
          $(this).addClass('active')
        }
      })
      $('.slide-in').each(function () {
        let scroll = $(window).scrollTop() //TOPからのスクロール量を計測
        let position = $(this).offset().top //TOPからの位置を計測
        let windowHeight = $(window).height() //ページ全体の高さ計測
        if (scroll - 150 > position - windowHeight) {
          $(this).addClass('active')
        }
      })
    } else {
      //768px以下の場合
      $('.fade-in').each(function () {
        let scroll = $(window).scrollTop() //TOPからのスクロール量を計測
        let position = $(this).offset().top //TOPからの位置を計測
        let windowHeight = $(window).height() //ページ全体の高さ計測
        if (scroll > position - windowHeight) {
          $(this).addClass('active')
        }
      })
      $('.slide-in').each(function () {
        let scroll = $(window).scrollTop() //TOPからのスクロール量を計測
        let position = $(this).offset().top //TOPからの位置を計測
        let windowHeight = $(window).height() //ページ全体の高さ計測
        if (scroll - 20 > position - windowHeight) {
          $(this).addClass('active')
        }
      })
    }
  }
  $(window).scroll(function () {
    //スクロール時の処理
    fadeinanime()
  })
  $(document).ready(function () {
    fadeinanime()
    $('.archiveVer').addClass('active')
  })
  // ######  ##      ## #### ########  ######## ########
  // ##    ## ##  ##  ##  ##  ##     ## ##       ##     ##
  // ##       ##  ##  ##  ##  ##     ## ##       ##     ##
  //  ######  ##  ##  ##  ##  ########  ######   ########
  //       ## ##  ##  ##  ##  ##        ##       ##   ##
  // ##    ## ##  ##  ##  ##  ##        ##       ##    ##
  //  ######   ###  ###  #### ##        ######## ##     ##
  if ($('.single-swiper__container')[0]) {
    // リクルート
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const mvSwiper = new Swiper('.single-swiper__container', {
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 1500, // アニメ速度
      loop: true, // ループ
      spaceBetween: 15,
      loopAdditionalSlides: 3, //ループ演出用のクローン数を増やして安定化させる
      centeredSlides: true,
      slidesPerView: 1.2, //表示数変更
      autoplay: {
        delay: 2500, // 待機時間
        disableOnInteraction: false, // 操作されたらオート解除
      },
      breakpoints: {
        768: {
          spaceBetween: 25,
          slidesPerView: 4.4, //表示数変更
        },
      },
    })
  }
  if ($('.TOPcase-swiper-container')[0]) {
    const topcaseSwiper = new Swiper('.TOPcase-swiper-container', {
      effect: 'slide',
      speed: 1500,
      loop: true,
      spaceBetween: 15,
      centeredSlides: true,
      slidesPerView: 1.2, //表示数変更
      autoplay: {
        delay: 2000, // 待機時間
        disableOnInteraction: false, // 操作されたらオート解除
      },
      breakpoints: {
        768: {
          spaceBetween: 25,
          slidesPerView: 4.4, //表示数変更
        },
      },
    })
  }
  // ########    ###     #######
  // ##         ## ##   ##     ##
  // ##        ##   ##  ##     ##
  // ######   ##     ## ##     ##
  // ##       ######### ##  ## ##
  // ##       ##     ## ##    ##
  // ##       ##     ##  ##### ##
  $('.js-Qbtn').click(function () {
    $(this).toggleClass('active')
    $(this).siblings('.js-hide').slideToggle()
  })
  //  ########   #######  ########  ##     ## ########
  //  ##     ## ##     ## ##     ## ##     ## ##     ##
  //  ##     ## ##     ## ##     ## ##     ## ##     ##
  //  ########  ##     ## ########  ##     ## ########
  //  ##        ##     ## ##        ##     ## ##
  //  ##        ##     ## ##        ##     ## ##
  //  ##         #######  ##         #######  ##
  $('.popup-modal').magnificPopup({
    type: 'inline',
    preloader: false,
  })
  // ##      ## ########     ###    ########  ########  #### ##    ##  ######
  // ##  ##  ## ##     ##   ## ##   ##     ## ##     ##  ##  ###   ## ##    ##
  // ##  ##  ## ##     ##  ##   ##  ##     ## ##     ##  ##  ####  ## ##
  // ##  ##  ## ########  ##     ## ########  ########   ##  ## ## ## ##   ####
  // ##  ##  ## ##   ##   ######### ##        ##         ##  ##  #### ##    ##
  // ##  ##  ## ##    ##  ##     ## ##        ##         ##  ##   ### ##    ##
  //  ###  ###  ##     ## ##     ## ##        ##        #### ##    ##  ######
  // テキストを1文字ずつ<span>で囲って分割
  class SpanWrap {
    constructor() {
      this.settings = {
        target: '.js-span-wrap-text',
        isDataTxt: false,
      }
      this.targets = ''
      this.targetLength = 0
      this.nodes = []
      this.convertContents = []
    }
    init(options) {
      this.setup(options)
      this.getNodes()
      this.convert()
      this.set()
    }
    setup(options) {
      this.settings = Object.assign(
        {
          target: this.settings.target,
          isDataTxt: this.settings.datatxt,
        },
        options || {}
      )
      this.targets = document.querySelectorAll(this.settings.target)
      this.targetLength = this.targets.length
    }
    getNodes() {
      for (let target of this.targets) {
        let nodes = target.childNodes
        this.nodes.push(nodes)
      }
    }
    convert() {
      for (let i = 0; i < this.targetLength; i++) {
        // 空の配列を追加
        this.convertContents.push([])
        for (let node of this.nodes[i]) {
          if (node.nodeType === 3) {
            // テキストの場合
            //テキストから空白削除
            let text = node.textContent.replace(/\s+/g, '')
            if (this.settings.isDataTxt) {
              text.split('').forEach((v) => {
                this.convertContents[i].push('<span data-txt="' + v + '">' + v + '</span>')
              })
            } else {
              text.split('').forEach((v) => {
                this.convertContents[i].push('<span>' + v + '</span>')
              })
            }
          } else {
            // テキスト以外
            this.convertContents[i].push(node.outerHTML)
          }
        }
      }
    }
    set() {
      for (let i = 0; i < this.targetLength; i++) {
        this.targets[i].innerHTML = this.convertContents[i].join('')
      }
    }
  } //600px以上の場合
  const spanWrap = new SpanWrap()
  spanWrap.init()
  const spanWrapDataTxt = new SpanWrap()
  spanWrapDataTxt.init({
    target: '.js-span-wrap-text-datatxt',
    isDataTxt: true,
  })
})
